import React from 'react';
import { useTranslation } from 'react-i18next';
import './PorCobrarPorPagarToggle.scss';

const PorCobrarPorPagarToggle = ({ value, onChange, disabled = false }) => {
  const { t } = useTranslation('configuracion');
  const isPorPagar = value === true;

  const handleToggle = () => {
    if (!disabled && onChange) {
      onChange(!value);
    }
  };

  return (
    <div
      className={`por-cobrar-por-pagar-toggle ${disabled ? 'disabled' : ''}`}
      onClick={handleToggle}
    >
      <div className="toggle-labels">
        <span className={`label ${!isPorPagar ? 'active' : ''}`}>{t('obligationModal.toCollect')}</span>
        <span className={`label ${isPorPagar ? 'active' : ''}`}>{t('obligationModal.toPay')}</span>
      </div>
      <div className="toggle-pill">
        <div className={`pill-left ${!isPorPagar ? 'active' : ''}`}></div>
        <div className={`pill-right ${isPorPagar ? 'active' : ''}`}></div>
        <div className={`toggle-thumb ${isPorPagar ? 'right' : 'left'}`}></div>
      </div>
    </div>
  );
};

export default PorCobrarPorPagarToggle;
